// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"73538":"b6d4500bd98cb19c","92888":"f3da06ba4f2ad546"}[chunkId] + ".css";
};